import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DecorateModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* Magic wand with sparkles - represents decoration/embellishment */}
      {/* Wand body */}
      <path
        d="M4 20L14 10"
        stroke={color}
        strokeWidth={strokeWidth * 1.2}
        strokeLinecap="round"
      />
      {/* Wand tip star */}
      <path
        d="M14 10l2-2M14 10l-2-2M14 10l2 2M14 10l-2 2"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      {/* Sparkle 1 (top right) */}
      <circle cx="19" cy="5" r="1" fill={color} />
      <path d="M19 3v1M19 6v1M17 5h1M20 5h1" stroke={color} strokeWidth={strokeWidth * 0.75} strokeLinecap="round" />
      {/* Sparkle 2 (smaller) */}
      <circle cx="20" cy="12" r="0.75" fill={color} opacity="0.7" />
      <path d="M20 10.5v0.75M20 12.75v0.75M18.5 12h0.75M20.75 12h0.75" stroke={color} strokeWidth={strokeWidth * 0.5} strokeLinecap="round" opacity="0.7" />
    </BaseIcon>
  ),
);

DecorateModeIcon.displayName = 'DecorateModeIcon';
